<ng-template [ngTemplateOutlet]="templateOutlet"></ng-template>
